<template>
    <v-container class="site-regulation"> 
            <v-tabs
                v-model="tab"
                color="#37a8ce"
                centered
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
                grow
                >
                <v-tabs-slider :class="$style.loginSlider"></v-tabs-slider>
                <v-tab  :key="0" :class="$style.registerTab">
                    <str index="site_regulation > overview" />
                </v-tab>
                <v-tab :key="1" :class="$style.registerTab">
                    <str index="site_regulation > terms of use" />
                </v-tab>
                <v-tab :key="2" :class="$style.registerTab">
                    <str index="site_regulation > privacy policy" />
                </v-tab>
                <v-tab :key="3" :class="$style.registerTab">
                    <str index="site_regulation > security" />
                </v-tab>                

                <v-tabs-items v-model="tab" :class="$style.siteRegulationWrapper">
                    <v-tab-item>
                        <Overview />
                    </v-tab-item>

                    <v-tab-item>
                        <TermsOfUse />
                    </v-tab-item>
                    
                    <v-tab-item>
                        <PrivacyPolicy />
                    </v-tab-item>
                    
                    <v-tab-item>
                        <Security />
                    </v-tab-item>
                </v-tabs-items>              
            </v-tabs>

    </v-container>
</template>

<script>
import Overview from '@/components/SiteRegulation/Overview.vue';
import TermsOfUse from '@/components/SiteRegulation/TermsOfUse.vue';
import PrivacyPolicy from '@/components/SiteRegulation/PrivacyPolicy.vue';
import Security from '@/components/SiteRegulation/Security.vue';


export default {
    name: "SiteRegulation",
    components: {
        Overview,
        TermsOfUse,
        PrivacyPolicy,
        Security
    },          
    data: function(){
        return {
            tab: null
        }
    },
    created: function(){
        this.setTab();
    },
    methods: {
        setTab: function(){
            this.tab=0;
            if (this.siteRegulationTargetTab !== undefined){
                switch(this.siteRegulationTargetTab){
                    default:
                        this.tab=0;
                    break;

                    case "terms_of_use":
                        this.tab=1;
                    break;

                    case "privacy_policy":
                        this.tab=2;
                    break;

                    case "security":
                        this.tab=3;
                    break;
                }
            }
            
            return;
        }
    },
    computed: {
        siteRegulationTargetTab: function(){
            return this.$store.getters.siteRegulationTargetTab;
        }        
    },
    watch: {
        siteRegulationTargetTab: function(){
            this.setTab();
        }
    }
}
</script>

<style module>

.loginViewWrapper {
    position: relative;
}
    .loginCloseBtn {
        position: absolute;
        right: 4.5%;
        top: 15%;
    }

.loginTab, .registerTab {
    font-size: 17pt !important;
    font-weight: 400 ;
    text-transform: initial !important;
    
}
@media only screen and (max-width: 425px) {
    .loginTab, .registerTab{
        font-size:15px !important;
        font-weight: 500 ;
    }
	}

.loginSlider {
    margin-top: 10px;
}
@media only screen and (max-width: 425px) {
    .loginSlider{
        display:none;
    }
}

.siteRegulationWrapper{
    max-height: 600px;
    overflow-y: auto;
}

.siteRegulationWrapper::-webkit-scrollbar {
    width: 0.8em;
}

.siteRegulationWrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
}

.siteRegulationWrapper::-webkit-scrollbar-thumb {
    background-color: #d7d7d7;
    outline: 1px solid slategrey;
    border-radius: 5px;
}
</style>

<style>
.site-regulation .v-tabs-bar__content{
    max-width: 1000px !important;
    margin: auto;
}

/* .loginViewDialog {
    border-radius: 25px !important;
} */
</style>